import { render, staticRenderFns } from "./BaseTabList.vue?vue&type=template&id=28379841&scoped=true&"
import script from "./BaseTabList.vue?vue&type=script&lang=js&"
export * from "./BaseTabList.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabList.vue?vue&type=style&index=0&id=28379841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28379841",
  null
  
)

export default component.exports